import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import './Login.css';

function Login() {
  const { isAuthenticated, login } = useAuth();
  const navigate = useNavigate();

  if (isAuthenticated) {
    return <Navigate to="/dashboard" />;
  }

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      await login(credentialResponse.credential);
      toast.success('Welcome to ReDoIt!');
      navigate('/dashboard');
    } catch (error) {
      console.error('Login failed:', error);
      toast.error('Login failed. Please try again.');
    }
  };

  const handleGoogleError = () => {
    toast.error('Google login failed. Please try again.');
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card card">
          <div className="login-header">
            <div className="login-logo">
              <span className="logo-icon">R</span>
            </div>
            <h1 className="login-title">Welcome to ReDoIt</h1>
            <p className="login-description">
              Sign in to start reimagining your spaces
            </p>
          </div>

          <div className="login-form">
            <div className="google-login-wrapper">
              <GoogleLogin
                onSuccess={handleGoogleSuccess}
                onError={handleGoogleError}
                size="large"
                width="300"
                text="signin_with"
                shape="rectangular"
                theme="filled_black"
              />
            </div>
          </div>

          <div className="login-footer">
            <p>
              By signing in, you agree to our{' '}
              <a href="/terms">Terms of Service</a> and{' '}
              <a href="/privacy">Privacy Policy</a>
            </p>
          </div>
        </div>

        <div className="login-features">
          <h2>Why ReDoIt?</h2>
          <ul>
            <li>
              <span className="feature-check">✓</span>
              AI-powered room visualization
            </li>
            <li>
              <span className="feature-check">✓</span>
              $1 per design - no subscription required
            </li>
            <li>
              <span className="feature-check">✓</span>
              Perfect for contractors & homeowners
            </li>
            <li>
              <span className="feature-check">✓</span>
              Upload your own material samples
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Login;
